import { render, staticRenderFns } from "./EditPartnerForm.vue?vue&type=template&id=097f1f21&"
import script from "./EditPartnerForm.vue?vue&type=script&lang=js&"
export * from "./EditPartnerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports